import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EmojiPickerService } from '@components/emoji-picker/emoji-picker.service';
import { FuiBadgeComponent, FuiIconComponent, FuiTooltipDirective } from '@fui/fui-components';
import { FormatterModule } from '@pipes/formater/formatter.module';
import { SanitizeHtmlPipe } from '@pipes/sanitize/sanitize.pipe';
import { StripHtmlPipe } from '@pipes/strip-html/strip-html.pipe';
import { BaseCellComponent } from './base-cell.component';
import { BoolCellComponent } from './bool-cell/bool-cell.component';
import { ColorCellComponent } from './color-cell/color-cell.component';
import { DatetimeCellComponent } from './datetime-cell/datetime-cell.component';
import { FileCellComponent } from './file-cell/file-cell.component';
import { FloatCellComponent } from './float-cell/float-cell.component';
import { GalleryCellComponent } from './gallery-cell/gallery-cell.component';
import { HtmlCellComponent } from './html-cell/html-cell.component';
import { IntegerCellComponent } from './integer-cell/integer-cell.component';
import { LinkCellComponent } from './link-cell/link-cell.component';
import { TableCellListComponent } from './list-cell/list-cell.component';
import { SwitcherCellComponent } from './switcher-cell.component';
import { TextCellComponent } from './text-cell/text-cell.component';

/**
 * Кастомизации рендера ячеек в табличном движке для определённых типов данных.
 * Ожидается, что любая кастомщина для ячеек с определёнными типами данных перекочует в этот модуль.
 */
@NgModule({
    declarations: [
        BaseCellComponent,
        BoolCellComponent,
        ColorCellComponent,
        DatetimeCellComponent,
        FileCellComponent,
        FloatCellComponent,
        IntegerCellComponent,
        GalleryCellComponent,
        HtmlCellComponent,
        LinkCellComponent,
        SwitcherCellComponent,
        TableCellListComponent,
        TextCellComponent,
    ],
    exports: [SwitcherCellComponent, TableCellListComponent],
    providers: [EmojiPickerService],
    imports: [
        CommonModule,
        FormatterModule,
        FuiTooltipDirective,
        SanitizeHtmlPipe,
        StripHtmlPipe,
        FuiBadgeComponent,
        FuiIconComponent,
    ],
})
export class TableCellsModule {}
